// 本地存储相关的工具函数
const STORAGE_KEYS = {
  SESSIONS: 'chat-sessions',
  CURRENT_SESSION: 'current-session-id',
  API_KEY: 'api-key',
  THEME: 'theme'
};

export const loadSessions = () => {
  const saved = localStorage.getItem(STORAGE_KEYS.SESSIONS);
  return saved ? JSON.parse(saved) : [{
    id: 'default',
    name: '新对话',
    messages: []
  }];
};

export const saveSession = (sessions) => {
  localStorage.setItem(STORAGE_KEYS.SESSIONS, JSON.stringify(sessions));
};

export const loadCurrentSessionId = () => {
  return localStorage.getItem(STORAGE_KEYS.CURRENT_SESSION) || 'default';
};

export const saveCurrentSessionId = (id) => {
  localStorage.setItem(STORAGE_KEYS.CURRENT_SESSION, id);
};

export const loadApiKey = () => {
  return localStorage.getItem(STORAGE_KEYS.API_KEY) || '';
};

export const saveApiKey = (key) => {
  localStorage.setItem(STORAGE_KEYS.API_KEY, key);
};

export const loadTheme = () => {
  return localStorage.getItem(STORAGE_KEYS.THEME) || 'light';
};

export const saveTheme = (theme) => {
  localStorage.setItem(STORAGE_KEYS.THEME, theme);
}; 